// extracted by mini-css-extract-plugin
export default {"component":"PopupBaseComponent_component__Teq7y"};